<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-tax-exemption-dialog-create
          v-if="$hasPermissionTo(['create tax exemptions'])"
          :year="yearFilter"
          @created="loadTaxExemptions"
        />
      </v-col>
      <v-spacer />

      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
        class="text-right"
      >
        <setup-payroll-tax-exemption-dialog-copy
          v-if="$hasPermissionTo(['create tax exemptions'])"
          :years="years"
          @created="loadTaxExemptions"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-autocomplete
          v-model="yearFilter"
          clearable
          :items="years"
          label="Year Filter"
          placeholder="Filter by year"
          item-text="value"
          item-value="id"
          @change="refreshData"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Tax Exemption's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in Tax Exemption here"
          append-icon="search"
          label="Search Tax Exemption"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :items="filteredTaxExemptions"
      :search="search"
      :loading="loading"
      :headers="headers"
      :single-expand="true"
      show-expand
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <v-btn
              icon
              @click="props.expand(!props.isExpanded);"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>

          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <span>
              {{ props.item.code }}
            </span>
          </td>

          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <span>
              {{ props.item.name }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected text-center':'border-bottom text-center' ">
            <span>
              {{ props.item.year }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected text-right':'border-bottom text-right' ">
            <span>
              {{ currencyFormatting(props.item.amount) }}
            </span>
          </td>

          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <span v-if="statusFilter">
              <setup-payroll-tax-exemption-dialog-edit
                v-if="$hasPermissionTo(['update tax exemptions'])"
                :tax-exemption="props.item"
                @updated="refreshData"
              />
              <setup-payroll-tax-exemption-dialog-delete
                v-if="$hasPermissionTo(['delete tax exemptions']) && $vuetify.breakpoint.mdAndUp"
                :tax-exemption="props.item"
                @deleted="refreshData"
              />
              <setup-payroll-tax-exemption-dialog-delete-mobile
                v-if="$hasPermissionTo(['delete tax exemptions']) && $vuetify.breakpoint.smAndDown"
                :tax-exemption="props.item"
                @deleted="refreshData"
              />
            </span>
            <span v-else>
              <setup-payroll-tax-exemption-dialog-restore
                v-if="$hasPermissionTo(['restore tax exemptions']) && $vuetify.breakpoint.mdAndUp"
                :tax-exemption="props.item"
                @restored="refreshData"
              />
              <setup-payroll-tax-exemption-dialog-restore-mobile
                v-if="$hasPermissionTo(['restore tax exemptions']) && $vuetify.breakpoint.smAndDown"
                :tax-exemption="props.item"
                @restored="refreshData"
              />
            </span>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="py-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <div
            style="background-color:white"
            class="pa-2"
          >
            <p v-html="item.description" />
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollTaxExemptionDialogCreate: () => import('@/components/hris/setup/payroll/tax-exemption/DialogCreate'),
      SetupPayrollTaxExemptionDialogEdit: () => import('@/components/hris/setup/payroll/tax-exemption/DialogEdit'),
      SetupPayrollTaxExemptionDialogDelete: () => import('@/components/hris/setup/payroll/tax-exemption/DialogDelete'),
      SetupPayrollTaxExemptionDialogDeleteMobile: () => import('@/components/hris/setup/payroll/tax-exemption/DialogDeleteMobile'),
      SetupPayrollTaxExemptionDialogRestore: () => import('@/components/hris/setup/payroll/tax-exemption/DialogRestore'),
      SetupPayrollTaxExemptionDialogRestoreMobile: () => import('@/components/hris/setup/payroll/tax-exemption/DialogRestoreMobile'),
      SetupPayrollTaxExemptionDialogCopy: () => import('@/components/hris/setup/payroll/tax-exemption/DialogCopy'),
    },
    data () {
      return {
        taxExemptions: [],
        trashedTaxExemptions: [],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Year',
            align: 'center',
            value: 'year',
          },
          {
            text: 'Max. Amount (RM)',
            align: 'right',
            value: 'amount',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        loading: false,
        years: [],
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    computed: {
      filteredTaxExemptions () {
        return this.statusFilter ? this.taxExemptions : this.trashedTaxExemptions
      },
    },
    created () {
      this.loading = true
      
      this.loadYears()

      this.refreshData()
    },
    methods: {
      loadTaxExemptions () {
        this.loading = true

        this.$api.taxExemptions().list({ year: this.yearFilter })
          .then(response => {
            this.taxExemptions = _.orderBy(response.data, ['code'], ['asc'])

            this.loading = false
          })
      },
      loadTrashedTaxExemptions () {
        this.loading = true

        this.$api.taxExemptions().listTrashed({ year: this.yearFilter })
          .then(response => {
            this.trashedTaxExemptions = _.orderBy(response.data, ['code'], ['asc'])

            this.loading = false
          })
      },
      loadYears () {
        this.$api.taxExemptions().listYears()
          .then(response => {
            this.years = response.data.sort((a, b) => b - a)

            this.loading = false
          })
      },
      refreshData () {
        this.loadYears()
        this.loadTaxExemptions()
        this.loadTrashedTaxExemptions()
      },
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>

<style scoped>
.remove-bottom-border {
  border-bottom: 0px !important
}

.selected{
  background-color: rgba(0, 0, 0, .05);
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
